export const print = (message, type = 'log') => {
  if (process.env.NODE_ENV === 'development') {
    console[type](message)
  }
}
